import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import CoursesDetailsTab from './tabs/CoursesDetailsTab';
import CoursesAttendersListItem from '../courses-attenders/CoursesAttendersListItem';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <CoursesDetailsTab {...props} />
	},
	{
		id: 'courses_attenders',
		title: 'TAB_USERS_COURSES',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, refresh, updateRefresh }) => (
			<DetailsChildrenTab
				module="courses_users"
				content={{ type: 'list', itemLayout: CoursesAttendersListItem, id: 'coursesAttendersView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'crus_crss_uid', filt_clause: 'equals', filt_value: model.crss_uid }]}
			/>
		)
	}
];

export default tabs;
